class CartGift extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
        this.cartModal = document.querySelector("cart-modal");
        this.sectionId = this.cartModal.getAttribute("data-section-id");
        this.gift1Threshold = parseFloat(this.getAttribute("data-gift-1-threshold"));
        this.gift1VariantId = this.getAttribute("data-gift-1-variant-id");
        this.gift2Threshold = parseFloat(this.getAttribute("data-gift-2-threshold"));
        this.gift2VariantId = this.getAttribute("data-gift-2-variant-id");
    
        this.checkGiftProducts();
    }
  
    async addProductToCart(variantId) {
        const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                _freeGift: true,
              }
            }
          ],
          sections: [this.sectionId, "cart-bubble"],
          sections_url: window.location.pathname
        }),
      });
      const data = await response.json();
      await this.updateCart(data)
    }
  
    async removeProductFromCart(key) {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: key,
          quantity: 0,
          sections: [this.sectionId, "cart-bubble"],
          sections_url: window.location.pathname
        }),
      });
      const data = await response.json();
      await this.updateCart(data)
    }
  
    async updateCart(data) {
        this.cartModal.updateFromSectionHtml(data.sections[this.sectionId]);
        document.dispatchEvent(new CustomEvent("cart-bubble-ajax-init",{
            detail: {
                i: data.sections["cart-bubble"].match(/\d+/)
            }
        }));
    }
  
    checkGiftProducts() {
      const gift1Exist = this.getAttribute("data-gift-1-exist") === "true";
      const gift1Key = this.getAttribute("data-gift-1-key");
      const gift2Exist = this.getAttribute("data-gift-2-exist") === "true";
      const gift2Key = this.getAttribute("data-gift-2-key");
      const currentCartTotal = parseFloat(this.getAttribute("data-cart-total"));
  
      if (currentCartTotal >= this.gift1Threshold && !gift1Exist) {
        this.addProductToCart(this.gift1VariantId);
      } else if (currentCartTotal < this.gift1Threshold && gift1Exist) {
        this.removeProductFromCart(gift1Key);
      }
  
      if (currentCartTotal >= this.gift2Threshold && !gift2Exist) {
        this.addProductToCart(this.gift2VariantId);
      } else if (currentCartTotal < this.gift2Threshold && gift2Exist) {
        this.removeProductFromCart(gift2Key);
      }
    }
}
  
customElements.define("cart-gift", CartGift);